import { useMemo } from 'react'
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import {
  getUserNotifications,
  getUserNotificationsKey,
  markAsSeen,
} from '../api-client/notifications'
import { useAuth } from '../contexts/auth'

export default function useNotifications(type) {
  const [{ isAuthenticated }] = useAuth()
  const queryClient = useQueryClient()

  const { data: notificationQuery = {} } = useQuery({
    queryKey: getUserNotificationsKey,
    queryFn: getUserNotifications,
    enabled: isAuthenticated,
  })

  const { mutate } = useMutation(markAsSeen)

  const notifications = useMemo(
    () =>
      (notificationQuery.notifications || []).reduce((result, notification) => {
        return {
          ...result,
          [notification.type]: [...(result[notification.type] || []), notification],
        }
      }, {}),
    [notificationQuery],
  )

  const filteredNotifications = notifications[type]
  const isNotifications = notificationQuery.totalCount > 0

  const markNotificationAsRead = (vehicleId, callBack) => {
    const hasNotification =
      Array.isArray(filteredNotifications) &&
      !!filteredNotifications.find((el) => el.vehicleId === vehicleId)

    if (hasNotification) {
      mutate(
        { vehicleId },
        {
          onSuccess: () => {
            queryClient.invalidateQueries(getUserNotificationsKey)
            callBack && callBack()
          },
        },
      )
    } else {
      callBack && callBack()
    }
  }

  const refetchNotifications = () => {
    queryClient.invalidateQueries(getUserNotificationsKey)
  }

  return {
    notifications,
    isNotifications,
    markNotificationAsRead,
    refetchNotifications,
  }
}
